import { usePdp } from '@context/PdpContext';
import { useTranslation } from 'next-i18next';

const useDeliveryStockLevel = () => {
  const { t } = useTranslation('pdp');
  const { selectedVariant } = usePdp();

  const calculateStockLevel = () => {
    const storeInventory =
      selectedVariant?.inventoryAggregated?.availableToSell;

    if (storeInventory === 0) {
      return 'outOfStock';
    }
    if (storeInventory && storeInventory < 5) {
      return 'low';
    }
    if (storeInventory && storeInventory >= 5 && storeInventory <= 10) {
      return 'medium';
    }
    if (storeInventory && storeInventory > 10) {
      return 'high';
    }
    return false;
  };

  const getStockLevelMessage = () => {
    if (calculateStockLevel() === 'outOfStock') {
      return t('product.out.of.stock');
    }
    if (calculateStockLevel() === 'low') {
      return t('product.low.stock.message', {
        stock: selectedVariant?.inventoryAggregated?.availableToSell,
      });
    }
    if (
      calculateStockLevel() === 'medium' ||
      calculateStockLevel() === 'high'
    ) {
      return t('product.in.stock');
    }
  };

  const stockLevel = calculateStockLevel() || null;
  const stockLevelMessage = getStockLevelMessage() || null;

  return {
    stockLevel,
    stockLevelMessage,
  };
};

export default useDeliveryStockLevel;
